import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
// Relative, not "@shared/..." - the standalone foyer-cms build aliases
// @shared to foyer-shared/dist (tsc output: no CSS, no font files).
import "../shared/fonts/cms.css";
import App from "./App";
import { installClientErrorReporting } from "@shared/clientErrors";
import { ThemeModeProvider } from "./ThemeMode";
import { ToastProvider } from "./components/toast";
import { initI18n } from "./i18n/instance";
import { LanguageProvider } from "./i18n/LanguageProvider";
import { enabledLanguages, initialLanguage } from "./i18n/languages";

// Uncaught errors and unhandled rejections go to POST /api/common/v1/client-errors,
// grouped server-side and listed under Settings > Client errors. Installed
// before render so a crash in the first render is caught too.
installClientErrorReporting(
  "cms",
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev"
);

const languages = enabledLanguages();
const language = initialLanguage(languages);

void initI18n(language).then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <LanguageProvider initial={language} languages={languages}>
        <ThemeModeProvider>
          <ToastProvider>
            <Suspense fallback={null}>
              <App />
            </Suspense>
          </ToastProvider>
        </ThemeModeProvider>
      </LanguageProvider>
    </React.StrictMode>
  );
});
